import * as userAction from '../actions/user.action';
import { WhoAmI$Response } from '@api/service';
import { createReducer, on } from '@ngrx/store';

export interface UserState {
  data: WhoAmI$Response;
  loaded: boolean;
  loading: boolean;
}

export const initialState: UserState = {
  data: null,
  loaded: false,
  loading: false
};

const userReducer = createReducer(
  initialState,
  on(userAction.getUser, state => ({ ...state, loading: true })),
  on(userAction.getUserFail, state => ({ ...state, loading: false, loaded: false })),
  on(userAction.getUserSuccess, (state, payload) => {
    const data = payload;
    return { ...state, data, loading: false, loaded: false };
  }),
  on(userAction.logoutUserSuccess, () => {
    return { ...initialState };
  })
);

export function reducer(state, action) {
  return userReducer(state, action);
}

export const getUserLoading = (state: UserState) => state.loading;
export const getUserLoaded = (state: UserState) => state.loaded;
export const getUser = (state: UserState) => {
  return state.data;
};
